






















































import CommonBase from "../CommonBase";
import {Component, Emit, Prop} from "vue-property-decorator";
import {DateTime, SimRow, Terminal} from "../../modules/models";
import {SimStatus, SimOperators} from "../../modules/constants";
import ContactLink from "@/components/shared/ContactLink.vue";

/**
 * Emits at-sim-status-refresh event that should be hooked to listener that reloads sim when triggered.
 * simLoading should be true when a (re)load of sim from server is in progress.
 */
@Component({
    components: {
        "at-contactlink": ContactLink,
    }
})
export default class SimStatusAlert extends CommonBase {
    @Prop()
    terminal!: Terminal;
    @Prop()
    sim!: SimRow | null;
    @Prop({default: false})
    simLoading!: boolean;

    get terminalActive() {
        return this.terminal != null && this.terminal.deactivated == null;
    }

    get isTelenorSim() {
        return this.sim != null &&
            this.sim.operator == SimOperators.telenor;
    }

    get isDeletedSim() {
        return this.sim != null &&
            this.sim.subscriptionStatusReported == SimStatus.deleted;
    }

    get deletedSimIsOldNews() {
        return this.terminal.lastSyncTs.isBefore(DateTime.now().prevDay().prevDay());
    }

    get doInactiveSimAlert() {
        return this.terminalActive &&
            this.sim != null &&
            this.sim.subscriptionStatusReported != SimStatus.pending &&
            this.sim.subscriptionStatusReported != SimStatus.active;
    }

    get doPendingInactiveSimAlert() {
        return this.terminalActive &&
            this.sim != null &&
            this.sim.subscriptionStatusWanted != this.sim.subscriptionStatusReported &&
            this.sim.subscriptionStatusWanted != SimStatus.pending &&
            this.sim.subscriptionStatusWanted != SimStatus.active;
    }

    get doMissingSimAlert() {
        return this.terminalActive && this.terminal.licenseType == 2 && this.terminal.simSerial && !this.sim;
    }

    get doPendingSimChangeAlert() {
        return this.wantedStatusTxt != "";
    }

    get doWaitingForTelenorActivationAlert() {
        return this.sim != null &&
            this.sim.subscriptionStatusReported != SimStatus.deleted &&
            this.sim.subscriptionStatusReported != SimStatus.pending &&
            this.sim.subscriptionStatusReported != this.sim.subscriptionStatusWanted &&
            this.sim.subscriptionStatusWanted == SimStatus.active &&
            this.sim.operator == SimOperators.telenor;
    }

    get hasAlert() {
        return this.isTelenorSim || this.doInactiveSimAlert || this.doPendingInactiveSimAlert || this.doMissingSimAlert || this.doPendingSimChangeAlert || this.doWaitingForTelenorActivationAlert;
    }

    get reportedStatusTxt() {
        if(this.sim) {
            const status = this.sim.subscriptionStatusReported;
            if(status == SimStatus.unknown) {
                return "Ukjendt status";
            } else if(status == SimStatus.paused) {
                return "Deaktivert";
            } else if(status == SimStatus.deleted) {
                return "Oppsagt";
            }
        }
        return "";
    }

    get wantedStatusTxt() {
        if (this.sim &&
            this.sim.subscriptionStatusReported != SimStatus.deleted &&
            this.sim.subscriptionStatusReported != SimStatus.pending &&
            this.sim.subscriptionStatusReported != this.sim.subscriptionStatusWanted) {

            const status = this.sim.subscriptionStatusWanted;
            if(status == SimStatus.active) {
                return "Venter på aktivering av simkort";
            } else if(status == SimStatus.paused) {
                return "Abonnement vil bli stoppet i løpet av noen dager";
            } else if(status == SimStatus.deleted) {
                return "Abonnement blir sagt opp";
            } else {
                return `Uventa (${status}`;
            }
        }
        return "";
    }

    @Emit("at-sim-status-refresh")
    refreshSim() { }
}
